
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("238Tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $17e2c305e5143e39$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createFromCapabilitiesMatrixSet", () => $17e2c305e5143e39$export$435b228518a973ff);
/**
 * @module ol/tilegrid/WMTS
 */ 
var $g5oyO = parcelRequire("g5oyO");

var $dpRHA = parcelRequire("dpRHA");
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles
 * outside this extent will be requested by {@link module:ol/source/Tile~TileSource} sources.
 * When no `origin` or `origins` are configured, the `origin` will be set to the
 * top-left corner of the extent.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e.
 * where the `x` and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left
 * to right and downwards. If not specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins,
 * i.e. where the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If
 * given, the array length should match the length of the `resolutions` array, i.e.
 * each resolution can have a different origin. Tile coordinates increase left to
 * right and downwards. If not specified, `extent` or `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each
 * resolution needs to match the zoom level. This means that even if a `minZoom`
 * is configured, the resolutions array will have a length of `maxZoom + 1`
 * @property {!Array<string>} matrixIds matrix IDs. The length of this array needs
 * to match the length of the `resolutions` array.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. The values here are the `TileMatrixWidth` and
 * `TileMatrixHeight` advertised in the GetCapabilities response of the WMTS, and
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent for
 * which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. The length of
 * this array needs to match the length of the `resolutions` array.
 */ /**
 * @classdesc
 * Set the grid pattern for sources accessing WMTS tiled-image servers.
 * @api
 */ class $17e2c305e5143e39$var$WMTSTileGrid extends (0, $g5oyO.default) {
    /**
   * @param {Options} options WMTS options.
   */ constructor(options){
        super({
            extent: options.extent,
            origin: options.origin,
            origins: options.origins,
            resolutions: options.resolutions,
            tileSize: options.tileSize,
            tileSizes: options.tileSizes,
            sizes: options.sizes
        });
        /**
     * @private
     * @type {!Array<string>}
     */ this.matrixIds_ = options.matrixIds;
    }
    /**
   * @param {number} z Z.
   * @return {string} MatrixId..
   */ getMatrixId(z) {
        return this.matrixIds_[z];
    }
    /**
   * Get the list of matrix identifiers.
   * @return {Array<string>} MatrixIds.
   * @api
   */ getMatrixIds() {
        return this.matrixIds_;
    }
}
var $17e2c305e5143e39$export$2e2bcd8739ae039 = $17e2c305e5143e39$var$WMTSTileGrid;
function $17e2c305e5143e39$export$435b228518a973ff(matrixSet, extent, matrixLimits) {
    /** @type {!Array<number>} */ const resolutions = [];
    /** @type {!Array<string>} */ const matrixIds = [];
    /** @type {!Array<import("../coordinate.js").Coordinate>} */ const origins = [];
    /** @type {!Array<number|import("../size.js").Size>} */ const tileSizes = [];
    /** @type {!Array<import("../size.js").Size>} */ const sizes = [];
    matrixLimits = matrixLimits !== undefined ? matrixLimits : [];
    const supportedCRSPropName = "SupportedCRS";
    const matrixIdsPropName = "TileMatrix";
    const identifierPropName = "Identifier";
    const scaleDenominatorPropName = "ScaleDenominator";
    const topLeftCornerPropName = "TopLeftCorner";
    const tileWidthPropName = "TileWidth";
    const tileHeightPropName = "TileHeight";
    const code = matrixSet[supportedCRSPropName];
    const projection = (0, $dpRHA.get)(code);
    const metersPerUnit = projection.getMetersPerUnit();
    // swap origin x and y coordinates if axis orientation is lat/long
    const switchOriginXY = projection.getAxisOrientation().substr(0, 2) == "ne";
    matrixSet[matrixIdsPropName].sort(function(a, b) {
        return b[scaleDenominatorPropName] - a[scaleDenominatorPropName];
    });
    matrixSet[matrixIdsPropName].forEach(function(elt) {
        let matrixAvailable;
        // use of matrixLimits to filter TileMatrices from GetCapabilities
        // TileMatrixSet from unavailable matrix levels.
        if (matrixLimits.length > 0) matrixAvailable = matrixLimits.find(function(elt_ml) {
            if (elt[identifierPropName] == elt_ml[matrixIdsPropName]) return true;
            // Fallback for tileMatrix identifiers that don't get prefixed
            // by their tileMatrixSet identifiers.
            if (!elt[identifierPropName].includes(":")) return matrixSet[identifierPropName] + ":" + elt[identifierPropName] === elt_ml[matrixIdsPropName];
            return false;
        });
        else matrixAvailable = true;
        if (matrixAvailable) {
            matrixIds.push(elt[identifierPropName]);
            const resolution = elt[scaleDenominatorPropName] * 0.28e-3 / metersPerUnit;
            const tileWidth = elt[tileWidthPropName];
            const tileHeight = elt[tileHeightPropName];
            if (switchOriginXY) origins.push([
                elt[topLeftCornerPropName][1],
                elt[topLeftCornerPropName][0]
            ]);
            else origins.push(elt[topLeftCornerPropName]);
            resolutions.push(resolution);
            tileSizes.push(tileWidth == tileHeight ? tileWidth : [
                tileWidth,
                tileHeight
            ]);
            sizes.push([
                elt["MatrixWidth"],
                elt["MatrixHeight"]
            ]);
        }
    });
    return new $17e2c305e5143e39$var$WMTSTileGrid({
        extent: extent,
        origins: origins,
        resolutions: resolutions,
        matrixIds: matrixIds,
        tileSizes: tileSizes,
        sizes: sizes
    });
}

});

parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $5DwXE = parcelRequire("5DwXE");

var $9DiKA = parcelRequire("9DiKA");

var $9pD6L = parcelRequire("9pD6L");

var $4mWlF = parcelRequire("4mWlF");

var $dpRHA = parcelRequire("dpRHA");

var $9jDAx = parcelRequire("9jDAx");
/**
 * @module ol/source/WMTS
 */ 
var $71uyY = parcelRequire("71uyY");

var $8jyNP = parcelRequire("8jyNP");

var $9pD6L = parcelRequire("9pD6L");

var $238Tz = parcelRequire("238Tz");

var $cwqvp = parcelRequire("cwqvp");

var $dpRHA = parcelRequire("dpRHA");
/**
 * Request encoding. One of 'KVP', 'REST'.
 * @typedef {'KVP' | 'REST'} RequestEncoding
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../tilegrid/WMTS.js").default} tileGrid Tile grid.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {RequestEncoding} [requestEncoding='KVP'] Request encoding.
 * @property {string} layer Layer name as advertised in the WMTS capabilities.
 * @property {string} style Style name as advertised in the WMTS capabilities.
 * @property {typeof import("../ImageTile.js").default} [tileClass]  Class used to instantiate image tiles. Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {string} [format='image/jpeg'] Image format. Only used when `requestEncoding` is `'KVP'`.
 * @property {string} [version='1.0.0'] WMTS version.
 * @property {string} matrixSet Matrix set.
 * @property {!Object} [dimensions] Additional "dimensions" for tile requests.
 * This is an object with properties named like the advertised WMTS dimensions.
 * @property {string} [url]  A URL for the service.
 * For the RESTful request encoding, this is a URL
 * template.  For KVP encoding, it is normal URL. A `{?-?}` template pattern,
 * for example `subdomain{a-f}.domain.com`, may be used instead of defining
 * each one separately in the `urls` option.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {Array<string>} [urls] An array of URLs.
 * Requests will be distributed among the URLs in this array.
 * @property {boolean} [wrapX=false] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMTS servers.
 * @api
 */ class $03da246cb7c9d812$var$WMTS extends (0, $71uyY.default) {
    /**
   * @param {Options} options WMTS options.
   */ constructor(options){
        // TODO: add support for TileMatrixLimits
        const requestEncoding = options.requestEncoding !== undefined ? options.requestEncoding : "KVP";
        // FIXME: should we create a default tileGrid?
        // we could issue a getCapabilities xhr to retrieve missing configuration
        const tileGrid = options.tileGrid;
        let urls = options.urls;
        if (urls === undefined && options.url !== undefined) urls = (0, $cwqvp.expandUrl)(options.url);
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            urls: urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : false,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {string}
     */ this.version_ = options.version !== undefined ? options.version : "1.0.0";
        /**
     * @private
     * @type {string}
     */ this.format_ = options.format !== undefined ? options.format : "image/jpeg";
        /**
     * @private
     * @type {!Object}
     */ this.dimensions_ = options.dimensions !== undefined ? options.dimensions : {};
        /**
     * @private
     * @type {string}
     */ this.layer_ = options.layer;
        /**
     * @private
     * @type {string}
     */ this.matrixSet_ = options.matrixSet;
        /**
     * @private
     * @type {string}
     */ this.style_ = options.style;
        // FIXME: should we guess this requestEncoding from options.url(s)
        //        structure? that would mean KVP only if a template is not provided.
        /**
     * @private
     * @type {RequestEncoding}
     */ this.requestEncoding_ = requestEncoding;
        this.setKey(this.getKeyForDimensions_());
        if (urls && urls.length > 0) this.tileUrlFunction = (0, $cwqvp.createFromTileUrlFunctions)(urls.map(this.createFromWMTSTemplate.bind(this)));
    }
    /**
   * Set the URLs to use for requests.
   * URLs may contain OGC conform URL Template Variables: {TileMatrix}, {TileRow}, {TileCol}.
   * @param {Array<string>} urls URLs.
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join("\n");
        this.setTileUrlFunction((0, $cwqvp.createFromTileUrlFunctions)(urls.map(this.createFromWMTSTemplate.bind(this))), key);
    }
    /**
   * Get the dimensions, i.e. those passed to the constructor through the
   * "dimensions" option, and possibly updated using the updateDimensions
   * method.
   * @return {!Object} Dimensions.
   * @api
   */ getDimensions() {
        return this.dimensions_;
    }
    /**
   * Return the image format of the WMTS source.
   * @return {string} Format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * Return the layer of the WMTS source.
   * @return {string} Layer.
   * @api
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Return the matrix set of the WMTS source.
   * @return {string} MatrixSet.
   * @api
   */ getMatrixSet() {
        return this.matrixSet_;
    }
    /**
   * Return the request encoding, either "KVP" or "REST".
   * @return {RequestEncoding} Request encoding.
   * @api
   */ getRequestEncoding() {
        return this.requestEncoding_;
    }
    /**
   * Return the style of the WMTS source.
   * @return {string} Style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Return the version of the WMTS source.
   * @return {string} Version.
   * @api
   */ getVersion() {
        return this.version_;
    }
    /**
   * @private
   * @return {string} The key for the current dimensions.
   */ getKeyForDimensions_() {
        const res = this.urls ? this.urls.slice(0) : [];
        for(const key in this.dimensions_)res.push(key + "-" + this.dimensions_[key]);
        return res.join("/");
    }
    /**
   * Update the dimensions.
   * @param {Object} dimensions Dimensions.
   * @api
   */ updateDimensions(dimensions) {
        Object.assign(this.dimensions_, dimensions);
        this.setKey(this.getKeyForDimensions_());
    }
    /**
   * @param {string} template Template.
   * @return {import("../Tile.js").UrlFunction} Tile URL function.
   */ createFromWMTSTemplate(template) {
        const requestEncoding = this.requestEncoding_;
        // context property names are lower case to allow for a case insensitive
        // replacement as some services use different naming conventions
        const context = {
            "layer": this.layer_,
            "style": this.style_,
            "tilematrixset": this.matrixSet_
        };
        if (requestEncoding == "KVP") Object.assign(context, {
            "Service": "WMTS",
            "Request": "GetTile",
            "Version": this.version_,
            "Format": this.format_
        });
        // TODO: we may want to create our own appendParams function so that params
        // order conforms to wmts spec guidance, and so that we can avoid to escape
        // special template params
        template = requestEncoding == "KVP" ? (0, $8jyNP.appendParams)(template, context) : template.replace(/\{(\w+?)\}/g, function(m, p) {
            return p.toLowerCase() in context ? context[p.toLowerCase()] : m;
        });
        const tileGrid = /** @type {import("../tilegrid/WMTS.js").default} */ this.tileGrid;
        const dimensions = this.dimensions_;
        return(/**
       * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
       * @param {number} pixelRatio Pixel ratio.
       * @param {import("../proj/Projection.js").default} projection Projection.
       * @return {string|undefined} Tile URL.
       */ function(tileCoord, pixelRatio, projection) {
            if (!tileCoord) return undefined;
            const localContext = {
                "TileMatrix": tileGrid.getMatrixId(tileCoord[0]),
                "TileCol": tileCoord[1],
                "TileRow": tileCoord[2]
            };
            Object.assign(localContext, dimensions);
            let url = template;
            if (requestEncoding == "KVP") url = (0, $8jyNP.appendParams)(url, localContext);
            else url = url.replace(/\{(\w+?)\}/g, function(m, p) {
                return localContext[p];
            });
            return url;
        });
    }
}
var $03da246cb7c9d812$export$2e2bcd8739ae039 = $03da246cb7c9d812$var$WMTS;
function $03da246cb7c9d812$export$6a2b1d2e791d254c(wmtsCap, config) {
    const layers = wmtsCap["Contents"]["Layer"];
    const l = layers?.find(function(elt) {
        return elt["Identifier"] == config["layer"];
    });
    if (!l) return null;
    const tileMatrixSets = wmtsCap["Contents"]["TileMatrixSet"];
    let idx;
    if (l["TileMatrixSetLink"].length > 1) {
        if ("projection" in config) idx = l["TileMatrixSetLink"].findIndex(function(elt) {
            const tileMatrixSet = tileMatrixSets.find(function(el) {
                return el["Identifier"] == elt["TileMatrixSet"];
            });
            const supportedCRS = tileMatrixSet["SupportedCRS"];
            const proj1 = (0, $dpRHA.get)(supportedCRS);
            const proj2 = (0, $dpRHA.get)(config["projection"]);
            if (proj1 && proj2) return (0, $dpRHA.equivalent)(proj1, proj2);
            return supportedCRS == config["projection"];
        });
        else idx = l["TileMatrixSetLink"].findIndex(function(elt) {
            return elt["TileMatrixSet"] == config["matrixSet"];
        });
    } else idx = 0;
    if (idx < 0) idx = 0;
    const matrixSet = /** @type {string} */ l["TileMatrixSetLink"][idx]["TileMatrixSet"];
    const matrixLimits = /** @type {Array<Object>} */ l["TileMatrixSetLink"][idx]["TileMatrixSetLimits"];
    let format = /** @type {string} */ l["Format"][0];
    if ("format" in config) format = config["format"];
    idx = l["Style"].findIndex(function(elt) {
        if ("style" in config) return elt["Title"] == config["style"];
        return elt["isDefault"];
    });
    if (idx < 0) idx = 0;
    const style = /** @type {string} */ l["Style"][idx]["Identifier"];
    const dimensions = {};
    if ("Dimension" in l) l["Dimension"].forEach(function(elt, index, array) {
        const key = elt["Identifier"];
        let value = elt["Default"];
        if (value === undefined) value = elt["Value"][0];
        dimensions[key] = value;
    });
    const matrixSets = wmtsCap["Contents"]["TileMatrixSet"];
    const matrixSetObj = matrixSets.find(function(elt) {
        return elt["Identifier"] == matrixSet;
    });
    let projection;
    const code = matrixSetObj["SupportedCRS"];
    if (code) projection = (0, $dpRHA.get)(code);
    if ("projection" in config) {
        const projConfig = (0, $dpRHA.get)(config["projection"]);
        if (projConfig) {
            if (!projection || (0, $dpRHA.equivalent)(projConfig, projection)) projection = projConfig;
        }
    }
    let wrapX = false;
    const switchXY = projection.getAxisOrientation().substr(0, 2) == "ne";
    let matrix = matrixSetObj.TileMatrix[0];
    // create default matrixLimit
    let selectedMatrixLimit = {
        MinTileCol: 0,
        MinTileRow: 0,
        // subtract one to end up at tile top left
        MaxTileCol: matrix.MatrixWidth - 1,
        MaxTileRow: matrix.MatrixHeight - 1
    };
    //in case of matrix limits, use matrix limits to calculate extent
    if (matrixLimits) {
        selectedMatrixLimit = matrixLimits[matrixLimits.length - 1];
        const m = matrixSetObj.TileMatrix.find((tileMatrixValue)=>tileMatrixValue.Identifier === selectedMatrixLimit.TileMatrix || matrixSetObj.Identifier + ":" + tileMatrixValue.Identifier === selectedMatrixLimit.TileMatrix);
        if (m) matrix = m;
    }
    const resolution = matrix.ScaleDenominator * 0.00028 / projection.getMetersPerUnit(); // WMTS 1.0.0: standardized rendering pixel size
    const origin = switchXY ? [
        matrix.TopLeftCorner[1],
        matrix.TopLeftCorner[0]
    ] : matrix.TopLeftCorner;
    const tileSpanX = matrix.TileWidth * resolution;
    const tileSpanY = matrix.TileHeight * resolution;
    let matrixSetExtent = matrixSetObj["BoundingBox"];
    if (matrixSetExtent && switchXY) matrixSetExtent = [
        matrixSetExtent[1],
        matrixSetExtent[0],
        matrixSetExtent[3],
        matrixSetExtent[2]
    ];
    let extent = [
        origin[0] + tileSpanX * selectedMatrixLimit.MinTileCol,
        // add one to get proper bottom/right coordinate
        origin[1] - tileSpanY * (1 + selectedMatrixLimit.MaxTileRow),
        origin[0] + tileSpanX * (1 + selectedMatrixLimit.MaxTileCol),
        origin[1] - tileSpanY * selectedMatrixLimit.MinTileRow
    ];
    if (matrixSetExtent !== undefined && !(0, $9pD6L.containsExtent)(matrixSetExtent, extent)) {
        const wgs84BoundingBox = l["WGS84BoundingBox"];
        const wgs84ProjectionExtent = (0, $dpRHA.get)("EPSG:4326").getExtent();
        extent = matrixSetExtent;
        if (wgs84BoundingBox) wrapX = wgs84BoundingBox[0] === wgs84ProjectionExtent[0] && wgs84BoundingBox[2] === wgs84ProjectionExtent[2];
        else {
            const wgs84MatrixSetExtent = (0, $dpRHA.transformExtent)(matrixSetExtent, matrixSetObj["SupportedCRS"], "EPSG:4326");
            // Ignore slight deviation from the correct x limits
            wrapX = wgs84MatrixSetExtent[0] - 1e-10 <= wgs84ProjectionExtent[0] && wgs84MatrixSetExtent[2] + 1e-10 >= wgs84ProjectionExtent[2];
        }
    }
    const tileGrid = (0, $238Tz.createFromCapabilitiesMatrixSet)(matrixSetObj, extent, matrixLimits);
    /** @type {!Array<string>} */ const urls = [];
    let requestEncoding = config["requestEncoding"];
    requestEncoding = requestEncoding !== undefined ? requestEncoding : "";
    if ("OperationsMetadata" in wmtsCap && "GetTile" in wmtsCap["OperationsMetadata"]) {
        const gets = wmtsCap["OperationsMetadata"]["GetTile"]["DCP"]["HTTP"]["Get"];
        for(let i = 0, ii = gets.length; i < ii; ++i){
            if (gets[i]["Constraint"]) {
                const constraint = gets[i]["Constraint"].find(function(element) {
                    return element["name"] == "GetEncoding";
                });
                const encodings = constraint["AllowedValues"]["Value"];
                if (requestEncoding === "") // requestEncoding not provided, use the first encoding from the list
                requestEncoding = encodings[0];
                if (requestEncoding === "KVP") {
                    if (encodings.includes("KVP")) urls.push(/** @type {string} */ gets[i]["href"]);
                } else break;
            } else if (gets[i]["href"]) {
                requestEncoding = "KVP";
                urls.push(/** @type {string} */ gets[i]["href"]);
            }
        }
    }
    if (urls.length === 0) {
        requestEncoding = "REST";
        l["ResourceURL"].forEach(function(element) {
            if (element["resourceType"] === "tile") {
                format = element["format"];
                urls.push(/** @type {string} */ element["template"]);
            }
        });
    }
    return {
        urls: urls,
        layer: config["layer"],
        matrixSet: matrixSet,
        format: format,
        projection: projection,
        requestEncoding: requestEncoding,
        tileGrid: tileGrid,
        style: style,
        dimensions: dimensions,
        wrapX: wrapX,
        crossOrigin: config["crossOrigin"]
    };
}



var $238Tz = parcelRequire("238Tz");

var $bV0pP = parcelRequire("bV0pP");
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $090d6c0ec3a01af8$var$projection = (0, $dpRHA.get)("EPSG:3857");
const $090d6c0ec3a01af8$var$projectionExtent = $090d6c0ec3a01af8$var$projection.getExtent();
const $090d6c0ec3a01af8$var$size = (0, $9pD6L.getWidth)($090d6c0ec3a01af8$var$projectionExtent) / 256;
const $090d6c0ec3a01af8$var$resolutions = new Array(14);
const $090d6c0ec3a01af8$var$matrixIds = new Array(14);
for(let z = 0; z < 14; ++z){
    // generate resolutions and matrixIds arrays for this WMTS
    $090d6c0ec3a01af8$var$resolutions[z] = $090d6c0ec3a01af8$var$size / Math.pow(2, z);
    $090d6c0ec3a01af8$var$matrixIds[z] = z;
}
const $090d6c0ec3a01af8$var$map = new (0, $5DwXE.default)({
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)(),
            opacity: 0.7
        }),
        new (0, $4mWlF.default)({
            opacity: 0.7,
            source: new (0, $03da246cb7c9d812$export$2e2bcd8739ae039)({
                attributions: 'Tiles \xa9 <a href="https://sampleserver6.arcgisonline.com/arcgis/rest/services/WorldTimeZones/MapServer/WMTS/">ArcGIS</a>',
                url: "https://sampleserver6.arcgisonline.com/arcgis/rest/services/WorldTimeZones/MapServer/WMTS/",
                layer: "WorldTimeZones",
                matrixSet: "GoogleMapsCompatible",
                format: "image/png",
                projection: $090d6c0ec3a01af8$var$projection,
                tileGrid: new (0, $238Tz.default)({
                    origin: (0, $9pD6L.getTopLeft)($090d6c0ec3a01af8$var$projectionExtent),
                    resolutions: $090d6c0ec3a01af8$var$resolutions,
                    matrixIds: $090d6c0ec3a01af8$var$matrixIds
                }),
                style: "default",
                wrapX: true
            })
        })
    ],
    target: "map",
    view: new (0, $9DiKA.default)({
        center: [
            -11158582,
            4813697
        ],
        zoom: 4
    })
});
const $090d6c0ec3a01af8$var$ol2d = $090d6c0ec3a01af8$var$map;
const $090d6c0ec3a01af8$var$ol3d = new (0, $cc3xD.default)({
    map: $090d6c0ec3a01af8$var$ol2d
});
const $090d6c0ec3a01af8$var$scene = $090d6c0ec3a01af8$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$090d6c0ec3a01af8$var$scene.terrainProvider = tp);
$090d6c0ec3a01af8$var$ol3d.setEnabled(true);
document.getElementById("enable").addEventListener("click", ()=>$090d6c0ec3a01af8$var$ol3d.setEnabled(!$090d6c0ec3a01af8$var$ol3d.getEnabled()));


//# sourceMappingURL=wmts.afbd8b07.js.map
